import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { Form } from 'reactstrap';
import { useTranslation } from 'react-i18next'

import {
  validationSchema, formsInputsData, typeInputProps,
} from './config';
import generateFormikInputs from '../../utils/generateFormikInputs';
import useStyles from './styles';
import PrimaryButton from '../common/buttons/PrimaryButton';
import CampaignFormQuestionnaire from '../CampaignFormQuestionnaire';
import { ImageYoutubeUploader, VideoUploader } from '../common/inputs/YoutubeUploader';
import { ErrorMessage } from '../common/AlertManager'
import FocusOnFirstError from '../common/Formik/FocusOnFirstError'


const CampaignForm = ({
  values, onSubmit, alertError, buttonText, campaignId, editMode, isErrorVisible,
}) => {
  const { t } = useTranslation(['translation', 'COMMON'])
  const classes = useStyles();
  const [isUploading, setIsUploading] = useState(false);

  return (
    <Formik
      initialValues={values}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      validateOnChange={false}
    >
      {(formikProps) => (
        <Form className={classes.form} onSubmit={formikProps.handleSubmit}>
          <div className={classes.inputsGrid}>
            {generateFormikInputs(formsInputsData, formikProps, false)}
          </div>

          <h4 className={classes.campaignTypeLabel}>{t('CAMPAIGN.CAMPAIGN_TYPE')}</h4>

          {generateFormikInputs(typeInputProps, formikProps, false, editMode)}

          <div className={formikProps.values.type !== 'Form' ? classes.typeFields : ''}>
            {formikProps.values.type === 'Video' && (
              <VideoUploader
                setFieldValue={value => formikProps.setFieldValue('video', value)}
                setFieldError={error => formikProps.setFieldError('video', error)}
                value={formikProps.values.video &&
                  formikProps.values.video.length === 11 && formikProps.values.video}
                campaignId={campaignId}
                id="video"
                editMode={editMode}
                setUploading={setIsUploading}
              />
            )}
            {formikProps.values.type === 'Image' && (
              <ImageYoutubeUploader
                setFieldValue={value => formikProps.setFieldValue('video', value)}
                setFieldError={error => formikProps.setFieldError('video', error)}
                value={formikProps.values.video &&
                  formikProps.values.video.length === 32 && formikProps.values.video}
                campaignId={campaignId}
                id="video"
                setUploading={setIsUploading}
              />
            )}
            {formikProps.values.type === 'Form' && (
              <CampaignFormQuestionnaire
                questions={formikProps.values.questions}
                setFieldValue={value => formikProps.setFieldValue('questions', value)}
                editMode={editMode}
                id="questions"
              />
            )}
          </div>
          <ErrorMessage error={alertError} visible={isErrorVisible} />
          <PrimaryButton type="submit" className={classes.button} disabled={formikProps.isSubmitting || isUploading}>
            {buttonText}
          </PrimaryButton>

          <FocusOnFirstError />
        </Form>
      )}
    </Formik>
  );
};

CampaignForm.defaultProps = {
  alertError: null,
  campaignId: null,
};

CampaignForm.propTypes = {
  values: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  alertError: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  campaignId: PropTypes.string,
  editMode: PropTypes.bool.isRequired,
  isErrorVisible: PropTypes.bool.isRequired,
};

export default CampaignForm;
